

<anms-device-template-info [template]="data[0]"></anms-device-template-info>
